var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "py-4"
  }, [_c('b-card', {
    attrs: {
      "header": "Bulk Upload",
      "header-bg-variant": "primary",
      "header-tag": "h5",
      "header-class": "font-weight-bold"
    }
  }, [_c('div', {
    staticClass: "dropzone",
    attrs: {
      "id": "myDropzone"
    }
  }, [!this.isUpload ? _c('div', [_c('vue-dropzone', {
    ref: "DropZoneData",
    attrs: {
      "include-styling": false,
      "useCustomSlot": true,
      "id": "dropzoneItems",
      "options": _vm.dropzoneOptions
    },
    on: {
      "vdropzone-files-added": _vm.filesUpload,
      "vdropzone-file-added": _vm.fileAdded
    }
  }, [_c('div', {
    staticClass: "dropzone-container"
  }, [_c('div', {
    staticClass: "file-selector"
  }, [_c('Icon'), _c('i', {
    staticClass: "bi bi-upload"
  }, [_vm._v("Drop Files Here")]), _c('br'), _c('span', [_vm._v(" or ")]), _c('br'), _c('button', {
    staticClass: "btn buttonBrowse",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Browse")])], 1)])])], 1) : _c('div', [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('h5', {
    staticClass: "card-title"
  }, [_vm._v(" Status : " + _vm._s(this.statusUpload) + " ")]), _c('h6', [_vm._v("Proccesed : " + _vm._s(this.indexUpload) + " / " + _vm._s(this.lengthUpload))]), _c('h6', {
    staticStyle: {
      "color": "#0060AF"
    }
  }, [_vm._v("Success : " + _vm._s(this.countRight) + " / " + _vm._s(this.lengthUpload))]), _c('h6', {
    staticStyle: {
      "color": "#df4759"
    }
  }, [_vm._v("Failed : " + _vm._s(this.countWrong) + " / " + _vm._s(this.lengthUpload))]), _c('b-overlay', {
    attrs: {
      "show": _vm.isOverlay,
      "rounded": "lg",
      "opacity": "0.6",
      "spinner-variant": "primary"
    }
  }, [_c('AttachmentList', {
    attrs: {
      "tempAttachments": _vm.getTempAttachments,
      "attachments": _vm.getAttachments
    }
  })], 1)], 1)])])])]), this.isData ? _c('div', [_c('ReviewData', {
    attrs: {
      "items": _vm.file_item
    }
  }), _c('b-button', {
    staticClass: "fix-bot-right",
    attrs: {
      "size": "lg",
      "variant": "warning"
    },
    on: {
      "click": _vm.resetAction
    }
  }, [_vm._v(" Reset ")])], 1) : _vm._e()], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }